import Select, { createFilter, components } from "react-select";
import "../../styles/select.css";

const CustomOption = ({ children, ...props }) => {
  // eslint-disable-next-line no-unused-vars
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
  const newProps = { ...props, innerProps: rest };
  return <components.Option {...newProps}>{children}</components.Option>;
};

const SpotSelect = props => {
  return (
    <div className="spot-select">
      <Select
        {...props}
        unstyled
        className="spot-select-container"
        classNamePrefix="spot-select"
        filterOption={createFilter({ ignoreAccents: false })}
        components={{ Option: CustomOption }}
        captureMenuScroll={false}
      />
    </div>
  );
};

export default SpotSelect;
